export const Marquee = () => {
  const words = ["Sweat", "Sculpt", "Repeat", "Breathe", "Burn", "Rise"];
  const strip = [...words, ...words, ...words];
  return (
    <div data-testid="marquee" className="relative border-y border-neutral-900 bg-black py-6 overflow-hidden">
      <div className="animate-marquee flex items-center gap-8">
        {strip.map((w, i) => (
          <span key={i} className="flex items-center gap-8 shrink-0">
            <span
              className={`font-display uppercase text-5xl sm:text-7xl leading-none ${
                i % 2 === 0 ? "text-stroke" : "neon-text"
              }`}
            >
              {w}
            </span>
            <span className="text-neon text-3xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
